<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ویرایش اطلاعات عنوان آدرس </h5>
      <form [formGroup]="EditAddressTitle" (submit)="SubmitEditAddressTitle()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">عنوان</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!EditAddressTitle.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button routerLink="/AddressTitle" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>

